module.exports = __webpack_public_path__ + "static/assets/1cdbced4759b27c09df52c649c4d4436.svg";